// src/context/CartContext.js
import React, { createContext, useState, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => {
  return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addProduct = (product, quantity, priceOption) => {
    setCartItems(prevItems => {
      const priceKey = priceOption.presentacion || priceOption.unidades;
      const existingItem = prevItems.find(
        item => item.id === product.id && (item.price.presentacion || item.price.unidades) === priceKey
      );
      if (existingItem) {
        return prevItems.map(item =>
          item.id === product.id && (item.price.presentacion || item.price.unidades) === priceKey
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        return [
          ...prevItems,
          { 
            id: product.id, 
            name: product.nombre, 
            quantity: quantity, 
            price: priceOption, 
            image: product.imagen,
          }
        ];
      }
    });
  };

  // --- NUEVA FUNCIÓN ---
  // Función para eliminar un producto del carrito
  const removeProduct = (productId, presentationKey) => {
    setCartItems(prevItems => {
      return prevItems.filter(item => !(item.id === productId && (item.price.presentacion || item.price.unidades) === presentationKey));
    });
  };

  // --- NUEVO CÁLCULO ---
  // Calcula el total de productos en el carrito (para el ícono)
  const cartItemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  // --- NUEVO CÁLCULO ---
  // Calcula el precio total del carrito
  const cartTotal = cartItems.reduce((sum, item) => sum + item.quantity * item.price.valor, 0);

  const value = {
    cartItems,
    addProduct,
    removeProduct, // <-- Exportamos la nueva función
    cartItemCount, // <-- Exportamos el conteo
    cartTotal,     // <-- Exportamos el total
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};